import {Box, Flex, Image, Text} from "@mantine/core";
import {IconMinus, IconPlus} from "@tabler/icons-react";
import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';

const _CartItem6 = ({component}) => {
    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >


            <Box
                mx={component?.customize_styles?.box_decoration?.margin_x}
                my={component?.customize_styles?.box_decoration?.margin_y}
                px={component?.customize_styles?.box_decoration?.padding_x}
                py={component?.customize_styles?.box_decoration?.padding_y}
                bg={component?.customize_styles?.box_decoration?.background_color}
                style={{
                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                }}
            >
                <Flex justify={'space-between'} align={'center'} py={20} px={10} style={{ boxShadow: "0px 0px 2px 0px #00000040", borderRadius: "10px" }}>
                    <Flex align={'center'} gap="xs">
                        <Box
                            w={component?.customize_styles?.image_decoration?.width}
                            h={component?.customize_styles?.image_decoration?.height}
                            // bg={component?.customize_styles?.image_decoration?.color}
                            style={{
                                borderRadius: `${component?.customize_styles?.image_decoration?.radius}px`
                            }}
                        >
                            <Image
                                style={{ width: "100%", height: "100%" }}
                                src=""
                                fallbackSrc={ProductPlaceholderImage}
                                alt=""
                                radius={component?.customize_styles?.image_decoration?.radius}
                            />
                        </Box>
                        <Box>
                            <Text
                                lineClamp={1}
                                translate="yes"
                                c={component?.customize_styles?.name_text_decoration?.color}
                                fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                fz={component?.customize_styles?.name_text_decoration?.font_size}
                                fs={component?.customize_styles?.name_text_decoration?.font_style}
                            >
                                Product Name
                            </Text>
                            <Text
                                mt={3}
                                fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                                fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                                c={component?.customize_styles?.product_price_text_decoration?.color}
                                // bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                                ta={component?.customize_styles?.product_price_text_decoration?.text_align}
                            >
                                $00.00
                            </Text>
                        </Box>
                    </Flex>
                    <Flex>
                        <Flex align={'center'} justify={'center'}>
                            <Flex align={'center'} justify={'center'} w={26} h={26} bg={'#27733e26'} style={{ borderRadius: "8px", cursor: "pointer" }}>
                                <IconMinus color="#27733E" size={16} />
                            </Flex>
                            <Text ml={15}> 1 </Text>
                            <Flex align={'center'} justify={'center'} w={26} h={26} bg={'#27733E'} ml={15} style={{ borderRadius: "8px", cursor: "pointer" }}>
                                <IconPlus color="#ffffff" size={16} />
                            </Flex>
                        </Flex>
                    </Flex>

                </Flex>
            </Box>
        </Box>
    )
}
export default _CartItem6;